import React from 'react';

const Thead = ({champsHeader, isWaiting}) => {
    const getWidthClass = (index) => {
        if (index === 0) return 'pl-4 pr-2 min-w-[120px]'; // N° de contrat
        if (index === 1) return 'px-2 min-w-[250px]'; // Intérimaire
        if (index === 2) return 'px-2 min-w-[300px]'; // Mission
        if (index === 4) return 'px-2 min-w-[100px]'; // ÉTAT
        return 'px-2';
    };

    return (
        <>
            <tr className="sticky top-0 z-10">
                {
                    isWaiting ? (
                        <>
                            {
                                champsHeader?.map((title, index) => (
                                    <th
                                        key={index}
                                        className={`sticky top-0 z-10 bg-gray-50 border-b border-gray-100 whitespace-nowrap ${getWidthClass(index)} py-3.5 text-left`}
                                    >
                                        <div className="h-2 bg-gray-200 rounded w-3/4"></div>
                                    </th>
                                ))
                            }
                            <th className="sticky top-0 z-10 bg-gray-50 border-b border-gray-100 py-3.5 pl-2 pr-3 min-w-[80px]"></th>
                        </>
                    ) : (
                        <>
                            {
                                champsHeader?.map((item, index) => (
                                    <th
                                        key={index}
                                        className={`sticky top-0 z-10 bg-gray-50 border-b border-gray-100 whitespace-nowrap ${getWidthClass(index)} py-3.5 text-left text-sm font-medium text-gray-700`}
                                    >
                                        {item.toUpperCase()}
                                    </th>
                                ))
                            }
                            <th className="sticky top-0 z-10 bg-gray-50 border-b border-gray-100 py-3.5 pl-2 pr-3 min-w-[80px]"></th>
                        </>
                    )
                }
            </tr>
        </>
    );
};

export default Thead;